module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/关于盛泰banner.993a9080.png";